import checkMatch from './checkMatch';
import isNode from './isNode';

export default function (element, filter) {
    let grandChildren = [];
    if (isNode(element)) {
        [].slice.call(element.children).forEach((child) => {
            [].slice.call(child.children).forEach((grandChild) => {
                if (!filter || (filter && checkMatch(grandChild, filter))) {
                    grandChildren.push(grandChild);
                }
            });
        });
    }
    return grandChildren;
}
